import { Direction } from '@/bewotec/openapi'
import { IAirline, IAirportData, IFlightClass } from '../flight/interfaces'
import { IFlightPriceComparison } from '../price/interfaces'
import { IError, IFetchRailOption } from '../rail/interfaces'
import { FlightClass } from './../interfaces'

export interface IBirthdates {
  [birthdayKey: string]: string
}

export interface ISelectedFilters {
  gateway: IMappedGateway | null
  flightDirection?: Direction | null
  airlines: string[]
  nonstop: boolean
  transportationClass?: FlightClass | null
}

export interface IMappedGateway {
  availableFlightDirections: Direction[]
  availableFlightClasses: FlightClass[]
  locCd: string
  locName: string
}

export enum FlexFlightCode {
  None = '',
  Gateway = 'Lade Flughäfen',
  Airport = 'Bitte Abflughafen wählen',
  FlightDirection = 'Bitte Flugrichtung wählen',
  TransportationClass = 'Bitte Flugklasse wählen',
  GatewayError = 'Leider ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut...',
  FlightError = 'Bitte Auswahl ändern - kein Wunschflug verfügbar.',
  Loading = 'Bitte warten. Flüge werden geladen.'
}

export interface IFilterKey {
  key: string
  listDisplay: string
  id?: string
}

export interface IGatewayItem extends IFilterKey {
  key: string
  listDisplay: string
  id?: string
}

export interface IFlightDirectionItem extends IFilterKey {
  key: string
  listDisplay: string
  id?: Direction
}

export interface ITransportationClassItem extends IFilterKey {
  key: string
  listDisplay: string
  id?: FlightClass
}

export interface IExpinetFlexFlightType {
  id: string
  price: number
  direction: Direction
  outboundFlight?: IOutboundInboundFlexFlight
  inboundFlight?: IOutboundInboundFlexFlight
}

export interface IOutboundInboundFlexFlight {
  airlines: IAirline[]
  arrival: IAirportData
  departure: IAirportData
  feederFlight: IFlight | null
  flightClass: IFlightClass
  mainFlight: IFlight
  stopArrival?: IAirportData
  stopDeparture?: IAirportData
}

export interface IFlight {
  airline: IAirline
  flightClass: IFlightClass
}

export interface IAirlineItem {
  display: string
  key: string
}

export interface IFlightDisplay {
  listDisplay: string
  id: string
  price: IFlightPriceComparison
}

export interface IFlightItem {
  key: string
  listDisplay: string
}

export interface IFlightItemDisplay extends IFlightDisplay {
  key: string
}

export type FlightItem = IFlightItem | IFlightItemDisplay

export type SelectableRailOptionsFlexFlight = IFetchRailOption | IError

export interface IExpinetFlightType {
  airlines: IAirline[]
  arrival: IAirportData
  departure: IAirportData
  direction: string
  feederFlight: IFlight | null
  id: number
  mainFlight: IFlight
  price: number
  refIndex?: number
  stopArrival?: IAirportData
  stopDeparture: IAirportData | null
}
